import { UploadTerminImage } from '@/domain/termine/components/TerminImage/UploadTerminImage';
import { useCreateTermineFormContext } from '@/domain/termine/features/CreateTermin/shared/useCreateTermineFormContext';

export function ImageFormField() {
  const { form } = useCreateTermineFormContext();

  return (
    <form.AppField name="terminBild">
      {(field) => (
        <UploadTerminImage
          image={field.state.value}
          variant="sheet"
          markierung={form.getFieldValue('markierung')}
          className="text-neutrals-700"
          onFileSelect={(file) => {
            field.handleChange(
              file ? { file, name: file.name, contentType: file.type } : null,
            );
          }}
        />
      )}
    </form.AppField>
  );
}
